module Elma.ViewModels {
    export class ProductViewModel extends Tapas.ViewModels.ProductViewModel {
        public mvm: Elma.ViewModels.MasterViewModel = Ftw.Base.Config.MasterViewModel as Elma.ViewModels.MasterViewModel;
        public listMode;
        constructor(data) {
            super(data);

            this.listMode = this.mvm.listMode;
       }

        public productLink = (link, name, id, country, beforePrice, priceWithCurrency, brand, primaryGroup, event) => {
            var priceSplit = priceWithCurrency.split(" ");
            //const priceWithoutCurrency = priceSplit[0].replace(",", ".");
            var priceWithoutCurrency = priceSplit[0];
            var currency = priceSplit[1];
            var beforePriceVat = (beforePrice/100)*25;
            var beforePriceWithVat = beforePrice + beforePriceVat;
            var eventType = "select_item";
            if (beforePriceWithVat > 0) {
                eventType = "select_item";
            }

            console.log("Productlink click", name, beforePriceWithVat, eventType);
            
            var windowAny = (window as any);
            windowAny.dataLayer.push({ ecommerce: null });
            windowAny.dataLayer.push({
                event: eventType,
                ecommerce: {
                    items: [{
                        item_name: name,
                        item_id: id,
                        affiliation: country,
                        discount: beforePriceWithVat,
                        price: priceWithoutCurrency,
                        item_brand: brand,
                        item_category: primaryGroup,
                        //item_list_name: '[item list name]',
                        //item_list_id: '[item list id]',
                        //item_variant: '[item variant]',
                        //location_id: '[location_id]',
                        //index: '[index number]',
                        quantity: '1',
                        currency: currency
                    }]
                }
            });
            if (event.ctrlKey) {
                window.open(
                    "/" + link,
                    "_blank"
                );
            } else {
                window.open(
                    "/" + link,
                    "_self"
                );
            }
        }
    }
}
